import React, { useEffect } from "react";
import "./Banner.scss";

export default function Banner() {
  const carouselItems = [
    {
      desktopImage: "/assets/img/slider/sea_desktop.png",
      mobileImage: "/assets/img/slider/water_mobile.png",
    },
    {
      desktopImage: "/assets/img/slider/desktop01.jpeg",
      mobileImage: "/assets/img/slider/mobile1.jpg",
    },
    {
      desktopImage: "/assets/img/slider/desktop2.jpg",
      mobileImage: "/assets/img/slider/mobile2.jpg",
    },
    {
      desktopImage: "/assets/img/slider/desktop3.jpg",
      mobileImage: "/assets/img/slider/mobile3.jpg",
      heading: "Trade Excellence",
      description:
        "Empowering Partnerships with Quality, Integrity, and Sustainability",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="hero-section hero-section-full-height">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-12 p-0">
            <div
              id="hero-slide"
              className="carousel slide carousel-fade"
              data-bs-ride="carousel"
              data-bs-interval="3000"
              data-bs-wrap="true"
              data-bs-pause="false"
            >
              <div className="carousel-inner">
                {carouselItems.map((item, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <picture>
                      <source
                        media="(max-width: 560px)"
                        srcSet={item.mobileImage}
                      />
                      <source
                        media="(min-width: 768px)"
                        srcSet={item.desktopImage}
                      />
                      <img
                        src={item.desktopImage}
                        className="carousel-image"
                        alt={item.heading || `Slide ${index + 1}`}
                      />
                    </picture>
                  </div>
                ))}
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#hero-slide"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>

              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#hero-slide"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
